import React from 'react';
import ReactDOM from 'react-dom';
// import App from './App';
import App from './scheduler/App'
import MonthlyCalendar from './scheduler/components/Calendar/MonthlyCalendar'

ReactDOM.render(<App />, document.getElementById('root'));
// ReactDOM.render(<MonthlyCalendar initYear='2019' initMonth='9' />, document.getElementById('root'));
